/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Swap_End_TitleInputs */

const en_us2_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`You changed 1 exercise today`);
	return /** @type {LocalizedString} */ (`You changed ${i?.count} exercises today`)
	
};

const pt_br2_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Você mudou 1 exercício hoje`);
	return /** @type {LocalizedString} */ (`Você mudou ${i?.count} exercícios hoje`)
	
};

const es_419_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Hoy cambiaste 1 ejercicio`);
	return /** @type {LocalizedString} */ (`Hoy cambiaste ${i?.count} ejercicios`)
	
};

const pt_pt2_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Mudaste 1 exercício hoje`);
	return /** @type {LocalizedString} */ (`Mudaste ${i?.count} exercícios hoje`)
	
};

const fr_fr2_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Tu as changé 1 exercice aujourd'hui`);
	return /** @type {LocalizedString} */ (`Tu as changé ${i?.count} exercices aujourd'hui`)
	
};

const de_de2_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Du hast heute 1 Übung geändert`);
	return /** @type {LocalizedString} */ (`Du hast heute ${i?.count} Übungen geändert`)
	
};

const it_it2_workout_swap_end_title = /** @type {(inputs: Workout_Swap_End_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Oggi hai cambiato 1 esercizio`);
	return /** @type {LocalizedString} */ (`Oggi hai cambiato ${i?.count} esercizi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "You changed 1 exercise today" |
* | * | "You changed {count} exercises today" |
*
* @param {Workout_Swap_End_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_end_title = /** @type {((inputs: Workout_Swap_End_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_End_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_end_title(inputs)
	if (locale === "es-419") return es_419_workout_swap_end_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_end_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_end_title(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_end_title(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_end_title(inputs)
	return en_us2_workout_swap_end_title(inputs)
});
export { workout_swap_end_title as "workout-swap.end_title" }